/**
 * Cart Enhancements — Consolidated
 * Free Shipping Bar, Delivery Date Picker, AOV Drawer Translations
 * Event-driven via AOV app events; no polling, no body-wide observers.
 */
(function() {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 10000; // €100 in cents
  var deliveryDateValue = '';
  var deliveryDateRevision = 0;
  var deliveryDateSave = null;
  var deliveryDateSaving = false;
  var debounceTimer = null;
  var adventProductIds = [1647701852258, 8018594431242, 8018928304394, 4834508931181];
  var adventCart = false;
  var cartWindowLoaded = false;
  var checkoutReplay = false;

  function updateAdventWindow(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    adventCart = cart.items.some(function(item) { return adventProductIds.indexOf(Number(item.product_id)) !== -1; });
    cartWindowLoaded = true;
    var inputs = document.querySelectorAll('#CartDrawerDeliveryDate, #CartPageDeliveryDate, .fudge-aov-date-input');
    for (var i = 0; i < inputs.length; i++) {
      var container = inputs[i].closest('.cart-delivery-date, #fudge-aov-date');
      if (!container) continue;
      var notice = container.querySelector('[data-advent-delivery-notice]');
      if (adventCart && !notice) {
        notice = document.createElement('p');
        notice.dataset.adventDeliveryNotice = 'true';
        notice.style.cssText = 'margin:6px 0;font-size:13px;line-height:1.4;color:#2D6A4F;';
        notice.textContent = 'Advents-Vorbestellung: Lieferung ab 15.11.2026. Bitte wählen Sie für diese Bestellung den 15.11.2026 oder einen späteren Termin. Sonntagszustellung in Frankfurt & Düsseldorf möglich.';
        container.appendChild(notice);
      } else if (!adventCart && notice) notice.remove();
      var result = validateDeliveryDate(inputs[i].value);
      var error = container.querySelector('.cart-delivery-date-error, .fudge-aov-date-error');
      if (adventCart && inputs[i].value && !result.valid) {
        if (!error || error.textContent !== result.error || error.style.display === 'none') showDateInputError(inputs[i], result.error);
      } else if (result.valid && error && error.style.display !== 'none') hideDateInputError(inputs[i]);
    }
  }

  // Recheck seasonal carts before checkout, including mixed carts and persisted dates.
  function checkAdventCheckout(e, input) {
    if (checkoutReplay || (cartWindowLoaded && !adventCart)) return false;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var target = e.type === 'submit' ? e.target : e.target.closest('button, a, [role="button"], input[type="submit"]');
    var submitter = e.submitter;
    fetchCartAndUpdate().then(function(cart) {
      if (!cart) { showDateInputError(input, 'Der Lieferzeitraum konnte nicht geprüft werden. Bitte versuchen Sie es erneut.'); return; }
      if (!validateAndShowDateError(input, true)) { if (input) input.focus(); return; }
      return (deliveryDateSave || Promise.resolve()).then(function() {
        checkoutReplay = true;
        try {
          if (e.type === 'submit' && target.requestSubmit) target.requestSubmit(submitter || undefined);
          else if (target) target.click();
        } finally { checkoutReplay = false; }
      });
    });
    return true;
  }

  // ── Helpers ──────────────────────────────────────────────

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function getAovDrawer() {
    return document.getElementById('AOV-CDMinimal');
  }

  // ── Translations ─────────────────────────────────────────

  var translations = {
    'View Warenkorb': 'Warenkorb ansehen',
    'View Cart': 'Warenkorb ansehen',
    'View cart': 'Warenkorb ansehen',
    'Cart (': 'Warenkorb (',
    'Cart:': 'Warenkorb:',
    'Cart': 'Warenkorb',
    'Subtotal:': 'Zwischensumme:',
    'Subtotal': 'Zwischensumme',
    'Checkout': 'Zur Kasse',
    'Add': 'Hinzufügen',
    'Remove': 'Entfernen',
    'Quantity': 'Menge',
    'Free Shipping': 'Kostenloser Versand',
    'free shipping': 'kostenloser Versand',
    'You are': 'Sie sind',
    'away from free shipping': 'von kostenlosem Versand entfernt',
    'Item': 'Artikel',
    'Items': 'Artikel',
    'Total': 'Gesamt',
    'Tax': 'MwSt.',
    'Shipping': 'Versand',
    'Continue Shopping': 'Weiter einkaufen',
    'Continue shopping': 'Weiter einkaufen',
    'Empty Cart': 'Warenkorb ist leer',
    'Your cart is empty': 'Ihr Warenkorb ist leer',
    'Your Cart is Empty': 'Ihr Warenkorb ist leer',
    'Product': 'Produkt',
    'Price': 'Preis',
    'View': 'Ansehen'
  };

  var grammarFixes = [
    {
      find: /Für 5 € bitten wir Sie, die Produkte dieser Bestellung eine Extra Geschenkverpackung/i,
      replace: 'Für 5 € verpacken wir Ihre Bestellung festlich in einer exklusiven Geschenkverpackung'
    },
    {
      find: /bitten wir Sie, die Produkte dieser Bestellung eine Extra Geschenkverpackung/i,
      replace: 'verpacken wir Ihre Bestellung festlich in einer exklusiven Geschenkverpackung'
    }
  ];

  function translateTextNodes(element) {
    if (!element) return;
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while (node = walker.nextNode()) {
      var text = node.textContent;
      var changed = false;
      for (var en in translations) {
        if (translations.hasOwnProperty(en) && text.indexOf(en) !== -1) {
          text = text.split(en).join(translations[en]);
          changed = true;
        }
      }
      for (var i = 0; i < grammarFixes.length; i++) {
        if (grammarFixes[i].find.test(text)) {
          text = text.replace(grammarFixes[i].find, grammarFixes[i].replace);
          changed = true;
        }
      }
      if (changed && node.textContent !== text) node.textContent = text;
    }
  }

  function translateAriaLabels(element) {
    if (!element) return;
    var labelled = element.querySelectorAll('[aria-label]');
    for (var i = 0; i < labelled.length; i++) {
      var el = labelled[i];
      var label = el.getAttribute('aria-label');
      if (!label) continue;
      var changed = false;
      for (var j = 0; j < grammarFixes.length; j++) {
        if (grammarFixes[j].find.test(label)) {
          label = label.replace(grammarFixes[j].find, grammarFixes[j].replace);
          changed = true;
        }
      }
      for (var en in translations) {
        if (translations.hasOwnProperty(en) && label.indexOf(en) !== -1) {
          label = label.split(en).join(translations[en]);
          changed = true;
        }
      }
      if (changed && el.getAttribute('aria-label') !== label) el.setAttribute('aria-label', label);
    }
  }

  function translateAovDrawer() {
    var drawer = getAovDrawer();
    if (drawer) {
      translateTextNodes(drawer);
      translateAriaLabels(drawer);
    }
  }

  // ── Free Shipping Bar ────────────────────────────────────

  function updateFreeShippingBar(totalCents) {
    // Theme cart drawer
    updateBarContainer(document.getElementById('CartDrawerFreeShipping'), totalCents);
    // Cart page
    updateBarContainer(document.getElementById('CartPageFreeShipping'), totalCents);
    // AOV drawer (our injected bar)
    updateBarContainer(document.getElementById('fudge-aov-fs-bar'), totalCents);
  }

  function updateBarContainer(container, totalCents) {
    if (!container) return;
    var textEl = container.querySelector('.fs-text');
    var fillEl = container.querySelector('.fs-fill');
    if (!textEl || !fillEl) return;

    var remaining = FREE_SHIPPING_THRESHOLD - totalCents;
    var pct = Math.min(100, (totalCents / FREE_SHIPPING_THRESHOLD) * 100);

    if (remaining > 0) {
      var message = 'Noch <strong>' + formatMoney(remaining) + '</strong> bis zur kostenlosen Lieferung';
      if (textEl.innerHTML !== message) textEl.innerHTML = message;
      textEl.style.color = '#333';
      textEl.style.fontWeight = '';
    } else {
      var message = '✓ Kostenlose Lieferung erreicht!';
      if (textEl.innerHTML !== message) textEl.innerHTML = message;
      textEl.style.color = '#2D6A4F';
      textEl.style.fontWeight = '600';
    }
    fillEl.style.width = pct + '%';
  }

  function fetchCartAndUpdate() {
    var revision = deliveryDateRevision;
    var saving = deliveryDateSaving;
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function(r) { if (!r.ok) throw new Error('Cart read failed'); return r.json(); })
      .then(function(cart) {
        updateFreeShippingBar(cart.total_price);
        updateAdventWindow(cart);
        // A delayed cart response must not overwrite a newer customer selection.
        if (revision === deliveryDateRevision && !saving && !deliveryDateSaving) {
          var date = validateDeliveryDate(cart.attributes && cart.attributes.Lieferdatum);
          if (date.valid) syncAllDateInputs(date.formatted);
        }
        return cart;
      })
      .catch(function() {});
  }

  function updateFromAovEvent(detail) {
    if (detail && detail.cart && typeof detail.cart.total_price === 'number') {
      updateFreeShippingBar(detail.cart.total_price);
      if (Array.isArray(detail.cart.items)) updateAdventWindow(detail.cart);
      else fetchCartAndUpdate();
    } else {
      fetchCartAndUpdate();
    }
  }

  // ── Delivery Date Validation & Sync ───────────────────────

  function parseDeliveryDate(str) {
    if (!str || typeof str !== 'string') return null;
    str = str.trim();
    if (!str) return null;
    var d, m, y;
    if (/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.test(str)) {
      var match = str.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
      d = parseInt(match[1], 10);
      m = parseInt(match[2], 10) - 1;
      y = parseInt(match[3], 10);
    } else if (/^(\d{4})-(\d{1,2})-(\d{1,2})$/.test(str)) {
      var match = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
      y = parseInt(match[1], 10);
      m = parseInt(match[2], 10) - 1;
      d = parseInt(match[3], 10);
    } else {
      return null;
    }
    var date = new Date(y, m, d);
    if (date.getFullYear() !== y || date.getMonth() !== m || date.getDate() !== d) {
      return null;
    }
    return date;
  }

  function validateDeliveryDate(value) {
    if (!value || typeof value !== 'string' || !value.trim()) {
      return { valid: false, error: 'Bitte wählen Sie ein Lieferdatum für Ihre Bestellung aus.' };
    }
    var date = parseDeliveryDate(value);
    if (!date) {
      return { valid: false, error: 'Bitte wählen Sie ein gültiges Datum im Format TT.MM.JJJJ aus.' };
    }
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date < today) {
      return { valid: false, error: 'Das gewählte Datum liegt in der Vergangenheit. Bitte wählen Sie ein zukünftiges Datum.' };
    }
    if (adventCart && date < new Date(2026, 10, 15)) {
      return { valid: false, error: 'Diese Bestellung enthält eine Advents-Vorbestellung. Früheste Lieferung: 15.11.2026. Bitte wählen Sie dieses oder ein späteres Datum.' };
    }
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear();
    var formattedGerman = day + '.' + month + '.' + year;
    return { valid: true, date: date, formatted: formattedGerman };
  }

  function showDateInputError(input, message) {
    if (!input) return;
    input.style.borderColor = '#c2185b';
    var container = input.closest('.cart-delivery-date') || input.closest('#fudge-aov-date') || input.parentNode;
    if (container) {
      var errorEl = container.querySelector('.cart-delivery-date-error, .fudge-aov-date-error, [id*="DeliveryDateError"]');
      if (errorEl) {
        errorEl.textContent = message || 'Bitte wählen Sie ein Lieferdatum für Ihre Bestellung aus.';
        errorEl.style.display = 'block';
      }
    }
  }

  function hideDateInputError(input) {
    if (!input) return;
    input.style.borderColor = '#d1d5db';
    var container = input.closest('.cart-delivery-date') || input.closest('#fudge-aov-date') || input.parentNode;
    if (container) {
      var errorEl = container.querySelector('.cart-delivery-date-error, .fudge-aov-date-error, [id*="DeliveryDateError"]');
      if (errorEl) {
        errorEl.style.display = 'none';
      }
    }
  }

  function validateAndShowDateError(input, isSubmitting) {
    if (!input) return false;
    var res = validateDeliveryDate(input.value);
    if (!res.valid) {
      if (isSubmitting || (input.value && input.value.trim())) {
        showDateInputError(input, res.error);
      }
      return false;
    }
    hideDateInputError(input);
    input.value = res.formatted;
    saveDeliveryDate(res.formatted);
    syncAllDateInputs(res.formatted, input);
    return true;
  }

  function syncAllDateInputs(formattedDate, sourceInput) {
    var result = validateDeliveryDate(formattedDate);
    if (!result.valid) return;
    formattedDate = result.formatted;
    if (deliveryDateValue !== formattedDate) {
      deliveryDateValue = formattedDate;
      deliveryDateRevision++;
    }
    var hiddenInput = document.getElementById('product-form-attribute-delivery-date');
    if (hiddenInput) hiddenInput.value = formattedDate;
    var allInputs = document.querySelectorAll('#CartDrawerDeliveryDate, #CartPageDeliveryDate, .fudge-aov-date-input, #delivery-date');
    for (var i = 0; i < allInputs.length; i++) {
      var inp = allInputs[i];
      if (inp === sourceInput) continue;
      if (inp.id === 'delivery-date') {
        var parsed = parseDeliveryDate(formattedDate);
        if (parsed) {
          var y = parsed.getFullYear();
          var m = String(parsed.getMonth() + 1).padStart(2, '0');
          var d = String(parsed.getDate()).padStart(2, '0');
          inp.value = y + '-' + m + '-' + d;
        }
      } else {
        inp.value = formattedDate;
      }
      hideDateInputError(inp);
    }
  }

  function saveDeliveryDate(value) {
    if (!value) return;
    if (deliveryDateSaving && deliveryDateValue === value) return deliveryDateSave;
    syncAllDateInputs(value);
    deliveryDateSaving = true;
    // Keep successive selections in order, so the last selection also wins on the server.
    deliveryDateSave = (deliveryDateSave || Promise.resolve()).then(function() {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Lieferdatum': value } }),
        credentials: 'same-origin'
      }).then(function(r) { if (!r.ok) throw new Error('Cart date save failed'); });
    }).catch(function() {});
    var currentSave = deliveryDateSave;
    currentSave.then(function() {
      if (deliveryDateSave === currentSave) deliveryDateSaving = false;
    });
    return currentSave;
  }

  function restoreDrawerDate() {
    var value = deliveryDateValue;
    if (!value) {
      var inputs = document.querySelectorAll('#delivery-date, #CartPageDeliveryDate, #CartDrawerDeliveryDate');
      for (var i = 0; i < inputs.length; i++) {
        var result = validateDeliveryDate(inputs[i].value);
        if (result.valid) {
          value = result.formatted;
          break;
        }
      }
    }
    if (value) syncAllDateInputs(value);
  }

  function setupDateInput(input) {
    if (!input || input.dataset.cartDateInit) return;
    input.dataset.cartDateInit = 'true';

    input.addEventListener('change', function() {
      validateAndShowDateError(input, false);
    });

    input.addEventListener('blur', function() {
      if (input.value && input.value.trim()) {
        validateAndShowDateError(input, false);
      }
    });

    input.addEventListener('input', function() {
      var res = validateDeliveryDate(input.value);
      if (res.valid) {
        hideDateInputError(input);
        saveDeliveryDate(res.formatted);
        syncAllDateInputs(res.formatted, input);
      }
    });
  }

  function bindCartFormCheckoutInterception(formId, inputId) {
    var form = document.getElementById(formId);
    if (!form || form.dataset.checkoutInterceptionBound) return;
    form.dataset.checkoutInterceptionBound = 'true';

    function checkAndBlock(e) {
      var input = document.getElementById(inputId);
      if (checkAdventCheckout(e, input)) return;
      if (!validateAndShowDateError(input, true)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (input) {
          input.focus();
          if (input.scrollIntoView) {
            input.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
        var btn = form.querySelector('.cart__checkout, [name="checkout"]');
        if (btn) btn.classList.remove('btn--loading');
        return false;
      }
    }

    form.addEventListener('submit', checkAndBlock, true);

    var checkoutBtns = form.querySelectorAll('.cart__checkout, [name="checkout"], .additional-checkout-buttons');
    for (var i = 0; i < checkoutBtns.length; i++) {
      checkoutBtns[i].addEventListener('click', checkAndBlock, true);
    }
  }

  function setupAovCheckoutInterception() {
    if (window._fudgeAovCheckoutBound) return;
    window._fudgeAovCheckoutBound = true;

    document.addEventListener('click', function(e) {
      var drawer = getAovDrawer();
      if (!drawer || !drawer.contains(e.target)) return;

      var target = e.target.closest('button, a, [role="button"], input[type="submit"]');
      if (!target) return;

      var text = (target.textContent || '').trim().toLowerCase();
      var href = (target.getAttribute('href') || '').toLowerCase();
      var cls = (target.className || '').toLowerCase();
      var id = (target.id || '').toLowerCase();

      // Check if this action triggers checkout
      var isCheckout = false;
      if (target.closest('.AOV-CDMinimal__Footer')) {
        // Any button/link in footer that is NOT "Warenkorb ansehen" or "Weiter einkaufen"
        if (text.indexOf('warenkorb') === -1 && text.indexOf('weiter') === -1 && text.indexOf('continue') === -1) {
          isCheckout = true;
        }
      }

      if (text.indexOf('kasse') !== -1 || text.indexOf('checkout') !== -1 ||
          href.indexOf('/checkout') !== -1 || cls.indexOf('checkout') !== -1 || id.indexOf('checkout') !== -1) {
        isCheckout = true;
      }

      if (isCheckout) {
        var dateInput = drawer.querySelector('.fudge-aov-date-input');
        if (checkAdventCheckout(e, dateInput)) return;
        if (dateInput && !validateAndShowDateError(dateInput, true)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          dateInput.focus();
          if (dateInput.scrollIntoView) {
            dateInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return false;
        }
      }
    }, true);

    document.addEventListener('submit', function(e) {
      var drawer = getAovDrawer();
      if (!drawer || !drawer.contains(e.target)) return;
      var dateInput = drawer.querySelector('.fudge-aov-date-input');
      if (checkAdventCheckout(e, dateInput)) return;
      if (dateInput && !validateAndShowDateError(dateInput, true)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        dateInput.focus();
        if (dateInput.scrollIntoView) {
          dateInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return false;
      }
    }, true);
  }

  // ── AOV Drawer Injection ─────────────────────────────────

  function createAovFreeShippingBar() {
    var bar = document.createElement('div');
    bar.id = 'fudge-aov-fs-bar';
    bar.style.cssText = 'padding:10px 16px;background:linear-gradient(135deg,#f9ede8 0%,#fce4ec 100%);border-radius:8px;margin:8px 12px;font-family:Outfit,sans-serif;font-size:13px;color:#2D6A4F;';
    bar.innerHTML =
      '<div class="fs-text" style="margin-bottom:6px;text-align:center;"></div>' +
      '<div style="background:#e8e8e1;border-radius:50px;height:6px;overflow:hidden;">' +
        '<div class="fs-fill" style="background:linear-gradient(90deg,#16a086,#0d7a68);height:100%;border-radius:50px;transition:width 0.4s ease;width:0%;"></div>' +
      '</div>';
    return bar;
  }

  function createAovDatePicker() {
    var container = document.createElement('div');
    container.id = 'fudge-aov-date';
    container.style.cssText = 'padding:10px 16px;margin:0 12px 8px;';
    container.innerHTML =
      '<label style="display:block;font-size:13px;font-weight:600;font-family:Outfit,sans-serif;margin-bottom:6px;color:#333;">📅 Gewünschtes Lieferdatum <span style="color:#e53e3e;" aria-hidden="true">*</span></label>' +
      '<input type="text" class="fudge-aov-date-input" placeholder="DD.MM.YYYY" pattern="\\d{2}\\.\\d{2}\\.\\d{4}" autocomplete="off" required aria-required="true" ' +
      'style="width:100%;padding:8px 10px;border:1px solid #d1d5db;border-radius:6px;font-family:Outfit,sans-serif;font-size:14px;box-sizing:border-box;" />' +
      '<div class="fudge-aov-date-error" style="display:none;margin-top:6px;padding:6px 10px;background:#fce4ec;border-radius:4px;font-size:12px;color:#c2185b;line-height:1.4;">' +
      'Bitte wählen Sie ein Lieferdatum für Ihre Bestellung aus.' +
      '</div>';
    return container;
  }

  function injectAovDrawer() {
    var drawer = getAovDrawer();
    if (!drawer) return;

    // Free shipping bar — insert after header if not already present
    if (!drawer.querySelector('#fudge-aov-fs-bar')) {
      var header = drawer.querySelector('.AOV-CDMinimal__Header');
      var fsBar = createAovFreeShippingBar();
      if (header && header.parentNode) {
        header.parentNode.insertBefore(fsBar, header.nextSibling);
      } else {
        drawer.insertBefore(fsBar, drawer.firstChild);
      }
    }

    // Delivery date picker — insert before footer if not already present
    var datePicker = drawer.querySelector('#fudge-aov-date');
    if (!datePicker) {
      var footer = drawer.querySelector('.AOV-CDMinimal__Footer');
      datePicker = createAovDatePicker();
      if (footer && footer.parentNode) {
        footer.parentNode.insertBefore(datePicker, footer);
      } else {
        drawer.appendChild(datePicker);
      }

    }

    // The app may retain, replace or clear the picker between drawer updates.
    // Restore synchronously on every injection, not only when creating the picker.
    setupDateInput(datePicker.querySelector('.fudge-aov-date-input'));
    restoreDrawerDate();

    // Specifically bind checkout buttons inside AOV drawer
    var checkoutButtons = drawer.querySelectorAll('.AOV-CDMinimal__CheckoutButton, [class*="CheckoutButton"], [class*="checkout"]');
    for (var b = 0; b < checkoutButtons.length; b++) {
      var btn = checkoutButtons[b];
      if (!btn.dataset.aovCheckoutBound) {
        btn.dataset.aovCheckoutBound = 'true';
        btn.addEventListener('click', function(e) {
          var input = drawer.querySelector('.fudge-aov-date-input');
          if (checkAdventCheckout(e, input)) return;
          if (input && !validateAndShowDateError(input, true)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            input.focus();
            if (input.scrollIntoView) {
              input.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return false;
          }
        }, true);
      }
    }

    translateAovDrawer();
    fetchCartAndUpdate();
  }

  window.fudgeInjectAovDrawer = injectAovDrawer;

  // ── Debounced drawer handler ─────────────────────────────

  function debouncedInject() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      injectAovDrawer();
    }, 200);
  }

  // ── Init ─────────────────────────────────────────────────

  function init() {
    // Mirror PDP changes immediately; its own calculator keeps native date validation.
    function syncProductDate(e) {
      if (!e.target.matches('#delivery-date')) return;
      var result = validateDeliveryDate(e.target.value);
      if (result.valid) saveDeliveryDate(result.formatted);
    }
    document.addEventListener('input', syncProductDate);
    document.addEventListener('change', syncProductDate);

    // Theme drawer date inputs
    setupDateInput(document.getElementById('CartDrawerDeliveryDate'));
    setupDateInput(document.getElementById('CartPageDeliveryDate'));

    // Checkout form validation & interception
    bindCartFormCheckoutInterception('CartDrawerForm', 'CartDrawerDeliveryDate');
    bindCartFormCheckoutInterception('CartPageForm', 'CartPageDeliveryDate');
    setupAovCheckoutInterception();

    // Initial refresh for theme cart
    fetchCartAndUpdate();

    // Try initial AOV injection (drawer may already exist)
    injectAovDrawer();

    // ── AOV app events ──
    document.addEventListener('aov:cart_changed', function(e) {
      updateFromAovEvent(e.detail);
      debouncedInject();
    });

    document.addEventListener('aov:item_added_to_cart', function(e) {
      updateFromAovEvent(e.detail);
      debouncedInject();
    });

    document.addEventListener('aov:item_removed', function(e) {
      updateFromAovEvent(e.detail);
      debouncedInject();
    });

    document.addEventListener('avada-cd-tool:ready', function() {
      debouncedInject();
    });

    // ── Shopify theme cart events (also dispatched by AOV util) ──
    document.addEventListener('cart:refresh', function() {
      bindCartFormCheckoutInterception('CartDrawerForm', 'CartDrawerDeliveryDate');
      bindCartFormCheckoutInterception('CartPageForm', 'CartPageDeliveryDate');
      setupDateInput(document.getElementById('CartDrawerDeliveryDate'));
      setupDateInput(document.getElementById('CartPageDeliveryDate'));
      fetchCartAndUpdate();
    });
    document.addEventListener('cart:updated', function() {
      bindCartFormCheckoutInterception('CartDrawerForm', 'CartDrawerDeliveryDate');
      bindCartFormCheckoutInterception('CartPageForm', 'CartPageDeliveryDate');
      setupDateInput(document.getElementById('CartDrawerDeliveryDate'));
      setupDateInput(document.getElementById('CartPageDeliveryDate'));
      fetchCartAndUpdate();
    });
    document.addEventListener('ajaxCart:updated', function() {
      bindCartFormCheckoutInterception('CartDrawerForm', 'CartDrawerDeliveryDate');
      bindCartFormCheckoutInterception('CartPageForm', 'CartPageDeliveryDate');
      setupDateInput(document.getElementById('CartDrawerDeliveryDate'));
      setupDateInput(document.getElementById('CartPageDeliveryDate'));
      fetchCartAndUpdate();
      debouncedInject();
    });
    document.addEventListener('ajaxProduct:added', function() {
      bindCartFormCheckoutInterception('CartDrawerForm', 'CartDrawerDeliveryDate');
      bindCartFormCheckoutInterception('CartPageForm', 'CartPageDeliveryDate');
      setupDateInput(document.getElementById('CartDrawerDeliveryDate'));
      setupDateInput(document.getElementById('CartPageDeliveryDate'));
      fetchCartAndUpdate();
      debouncedInject();
    });

    // ── Watch for AOV Cart Drawer additions & visibility changes ──
    function setupAovObserver() {
      var aovDialog = document.getElementById('AOV-CDMinimal');
      if (aovDialog && !aovDialog.dataset.observerAttached) {
        aovDialog.dataset.observerAttached = 'true';
        var dialogObserver = new MutationObserver(function() {
          debouncedInject();
        });
        dialogObserver.observe(aovDialog, { childList: true, subtree: false, attributes: true, attributeFilter: ['style', 'class'] });
      }
    }

    setupAovObserver();

    var aovRoot = document.getElementById('aov-cart-drawer');
    if (aovRoot) {
      var rootObserver = new MutationObserver(function() {
        debouncedInject();
        setupAovObserver();
      });
      rootObserver.observe(aovRoot, { childList: true, subtree: true });
    }

    if (!document.getElementById('AOV-CDMinimal')) {
      var bodyObserver = new MutationObserver(function() {
        if (document.getElementById('AOV-CDMinimal')) {
          debouncedInject();
          setupAovObserver();
          bodyObserver.disconnect();
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    // Watch cart button clicks to trigger injection immediately
    document.addEventListener('click', function(e) {
      if (e.target.closest('.site-header__cart, .js-drawer-open-right, [href*="/cart"], [data-action="open-cart"], [data-add-to-cart]')) {
        setTimeout(debouncedInject, 100);
        setTimeout(debouncedInject, 400);
        setTimeout(debouncedInject, 1000);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
